import { createStore, applyMiddleware, compose } from "redux";
import logger from "redux-logger";
import LogRocket from "logrocket";

import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducers";
import rootSaga from "./sagas";

const cookieconsent = window.initCookieConsent();
const initialState = {};
const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancers = [];
enhancers.push(sagaMiddleware);
if (process.env.NODE_ENV !== "test" && process.env.NODE_ENV !== "production") {
  enhancers.push(logger);
}
if (
  process.env.NODE_ENV === "production" &&
  cookieconsent.allowedCategory("performance")
) {
  enhancers.push(LogRocket.reduxMiddleware());
}
const enhancer = composeEnhancers(applyMiddleware(...enhancers));

export const makeEnhancedStore = (iState = initialState) =>
  createStore(rootReducer, iState, enhancer);

const store = makeEnhancedStore();

sagaMiddleware.run(rootSaga);

export default store;
